import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { GlobalStateContext } from "./Context";
import { useSnackbar } from 'notistack';

import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import MenuItem from '@mui/material/MenuItem';
import Drawer from '@mui/material/Drawer';
import MenuIcon from '@mui/icons-material/Menu';

function NavbarAlt() {
  const [open, setOpen] = React.useState(false);
  const { isLoggedIn, currentUsername, setIsLoggedIn, setCurrentUsername } = React.useContext(GlobalStateContext);
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const handleProfileClick = () => {
    if(isLoggedIn){
      navigate(`/Profile/${currentUsername}`);
    }
    else{
      enqueueSnackbar('Please, sign in to view Profile.', { variant: 'error' });
    }
  }

  const handleSignOut = () => {
    localStorage.removeItem('token');
    setIsLoggedIn(false);
    setCurrentUsername(null);
    navigate('/');
    enqueueSnackbar('You have been signed out.', { variant: 'success' });
  };

  const handleHomeClick = () => {
    navigate("/");
  }

  const handleLogoClick = () => {
    navigate('/');
  }

  return (
    <div>
      <AppBar
        position="fixed"
        sx={{
          boxShadow: 0,
          bgcolor: 'transparent',
          backgroundImage: 'none',
          mt: 2,
        }}
      >
        <Container maxWidth="lg">
          <Toolbar
            variant="regular"
            sx={(theme) => ({
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              flexShrink: 0,
              borderRadius: '999px',
              bgcolor:
                theme.palette.mode === 'light'
                  ? 'rgba(255, 255, 255, 0.4)'
                  : 'rgba(0, 0, 0, 0.4)',
              backdropFilter: 'blur(24px)',
              maxHeight: 40,
              border: '1px solid',
              borderColor: 'divider',
              boxShadow:
                theme.palette.mode === 'light'
                  ? `0 0 1px rgba(85, 166, 246, 0.1), 1px 1.5px 2px -1px rgba(85, 166, 246, 0.15), 4px 4px 12px -2.5px rgba(85, 166, 246, 0.15)`
                  : '0 0 1px rgba(2, 31, 59, 0.7), 1px 1.5px 2px -1px rgba(2, 31, 59, 0.65), 4px 4px 12px -2.5px rgba(2, 31, 59, 0.65)',
            })}
          >
            <Box
              sx={{
                flexGrow: 1,
                display: 'flex',
                alignItems: 'center',
                ml: '-18px',
                px: 0,
              }}
            >
              <img
                src="/logo.png"
                style={{ height: 30, cursor: 'pointer', marginLeft: 30, marginRight: 20 }}  // Adjust height and any additional styles as needed
                alt="logo of TechTestHub"
                onClick={handleLogoClick}
              />
              <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
                <MenuItem
                  onClick={handleHomeClick}
                  sx={{ py: '6px', px: '12px' }}
                >
                  <Typography variant="body2" color="text.primary">
                    Home
                  </Typography>
                </MenuItem>
                <MenuItem
                  onClick={handleProfileClick}
                  sx={{ py: '6px', px: '12px' }}
                >
                  <Typography variant="body2" color="text.primary">
                    Profile
                  </Typography>
                </MenuItem>
              </Box>
            </Box>
            <Box
              sx={{
                display: { xs: 'none', md: 'flex' },
                gap: 0.5,
                alignItems: 'center',
              }}
            >
              {isLoggedIn ? (
                <Button
                  color="primary"
                  variant="text"
                  size="small"
                  onClick={handleSignOut}
                >
                  Sign out
                </Button>
              ) : (
                <Button
                  color="primary"
                  variant="text"
                  size="small"
                  component="a"
                  href="/SignIn"
                  target="_blank"
                >
                  Sign in
                </Button>
                )}
              <Button
                color="primary"
                variant="contained"
                size="small"
                component="a"
                href="/SignUp"
                target="_blank"
              >
                Sign up
              </Button>
            </Box>
            <Box sx={{ display: { sm: '', md: 'none' } }}>
              <Button
                variant="text"
                color="primary"
                aria-label="menu"
                onClick={toggleDrawer(true)}
                sx={{ minWidth: '30px', p: '4px' }}
              >
                <MenuIcon />
              </Button>
              <Drawer anchor="right" open={open} onClose={toggleDrawer(false)}>
                <Box
                  sx={{
                    minWidth: '60dvw',
                    p: 2,
                    backgroundColor: 'background.paper',
                    flexGrow: 1,
                  }}
                >
                  <MenuItem onClick={handleHomeClick}>
                    Home
                  </MenuItem>
                  <MenuItem onClick={handleProfileClick}>
                    Profile
                  </MenuItem>
                  <Divider />
                  <MenuItem>
                    <Button
                      color="primary"
                      variant="contained"
                      component="a"
                      href="/SignUp"
                      target="_blank"
                      sx={{ width: '100%' }}
                    >
                      Sign up
                    </Button>
                  </MenuItem>
                  <MenuItem>
                  {isLoggedIn ? (
                    <Button
                      color="primary"
                      variant="outlined"
                      sx={{ width: '100%' }}
                      onClick={handleSignOut}
                    >
                      Sign out
                    </Button>
                  ) : (
                    <Button
                      color="primary"
                      variant="outlined"
                      component="a"
                      href="/SignIn"
                      target="_blank"
                      sx={{ width: '100%' }}
                    >
                      Sign in
                    </Button>
                  )}
                  </MenuItem>
                </Box>
              </Drawer>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    </div>
  );
}

// NavbarAlt.propTypes = {
//   mode: PropTypes.oneOf(['dark', 'light']).isRequired,
//   toggleColorMode: PropTypes.func.isRequired,
// };

export default NavbarAlt;